export default "__VITE_ASSET__QVphDtAW__"